export function isValid(sInvalid: any): boolean {
  if (!sInvalid) {
    return false
  } else {
    return true
  }
}

export function ObjectToString(value: object): string {
  return JSON.stringify(value)
}

export function StringToObject(value: string): object {
  return JSON.parse(value)
}
